import { connect } from 'react-redux';
import View from './LeadsView';
import * as selector from './LeadsSelector';

import {
  fetchLeads,
  setSortBy,
  resetOrder,
  resetSort,
  fetchNextPageLeads,
  setOrderBy,
} from './LeadsActions';
import { selectPortalName } from '../CommonSelectors/CommonAreaSelector';

const mapStateToProps = state => ({
  leadsList: selector.leadsList(state),
  nextPage: selector.nextPage(state),
  orderBy: selector.orderBy(state),
  showPagination: selector.showPagination(state),
  sortBy: selector.sortBy(state),
  totalAssets: selector.totalAssets(state),
  totalLeads: selector.totalLeads(state),
  nextOrderBy: selector.nextOrderBy(state),
  portalName: selectPortalName(state),
});

const mapDispatchToProps = dispatch => ({
  fetchLeads: (sortBy, orderBy) => dispatch(fetchLeads(sortBy, orderBy)),
  setSortBy: sortOption => dispatch(setSortBy(sortOption)),
  setOrderBy: orderOption => dispatch(setOrderBy(orderOption)),
  resetOrder: () => dispatch(resetOrder()),
  resetSort: () => dispatch(resetSort()),
  fetchNextPageLeads: (nextPage, sort, order) =>
    dispatch(fetchNextPageLeads(nextPage, sort, order)),
  setClient: clientId => ADV.util.Router.go2('ConsumerOverview', { clientId }),
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
